import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface SmallTextProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
    title?: string
}

export function SmallText({children, className, 'data-testid': testId, title}: SmallTextProps) {
    return <span className={cn('text-sm', className)} data-testid={testId} title={title}>{children}</span>
}
